import EmailForm from "../EmailForm";
import styles from "./ContainerHomeForm.module.css";

const ContainerHomeForm = () => (
  <section className={styles.formSection} dir="rtl" aria-labelledby="home-quote-title">
    <div className={styles.formRow}>
      <div className={styles.textColumn}>
        <h2 id="home-quote-title" className={styles.title}>הצעת מחיר מותאמת לעסק שלכם</h2>
        <p className={styles.description}>ספרו לנו בקצרה על העסק או המבנה, ונחזור אליכם לבדיקת התאמה ועלויות התקנה ותחזוקה.</p>
        <p className={styles.formHighlights}>היבואן המורשה של Falcon בישראל</p>
      </div>
      <div className={styles.formColumn}><EmailForm formLocation="home" /></div>
    </div>
  </section>
);

export default ContainerHomeForm;
